import React from 'react';
// import timeline from './icon/timelime.svg';
import timeline from './icon/timelime-color.png';

var divStyle = {
    backgroundColor: 'white',
    borderRadius: '20px',
    height: '20%',
    boxShadow: '5px 5px 10px #aaaaaa',
  };

  var divHead = {
    color: 'white',
    backgroundColor: '#5c6bc0',
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
    paddingTop: '5px',
    textAlign:'center'
  };
  
  var divinFooter = {
    color: 'white',
    backgroundColor: '#7986cb',
    borderBottomLeftRadius: '20px',
    borderBottomRightRadius: '20px',

    height: '20%',

  };


  var divBody = {
    color: '#757575',
    backgroundColor: '#ffffff',

    height: '20%',

  };

 var busreal = {}
export default class Card extends React.Component {
    constructor(props) {
    super(props);
    this.state = {};
    this.selectStation = this.selectStation.bind(this);
  }



    componentDidMount() {   
        this.loadData()
        this.intervalId = setInterval(() => this.loadData(), 2000);
    }
    componentWillReceiveProps(nextProps){  
        this.loadData();
        this.intervalId = setInterval(() => this.loadData(), 2000);
    }
  
    loadData() {

        const {transit} = this.props
        const { results } = transit

        let item = {}
        if(this.props.value){

            if ( results ){
                item = results  
                if(this.props.value)     
                
                for(var i = 0; i<Object.keys(item).length; i++){
                    var out = item[Object.keys(item)[i]].outbound
                    var inbound = item[Object.keys(item)[i]].inbound

                    if(out&&out.bus.vehicle_id===this.props.value.result.bus.vehicle_id){
                        busreal=out
                    }
                    if(inbound&&inbound.bus.vehicle_id===this.props.value.result.bus.vehicle_id ){
                        busreal=inbound
                    }
                }      
            }
        }
    }



    selectStation(station){
        console.log('----',{station})
    }

  render() {

    let fromStation = ''
    let toStation = ''
    let bus_line = ''
    let direction_name = ''
    let license_id = ''
    let predicted = ''
    let speed =''
    let predicted_arrival_sec =''
    let ti = ''
    let bustostop = ''
    let stopcount = ''
    let nearest = ''

    const { value } = this.props
    const { result } = value
    const item = result

    if(busreal.bus){
        ti = busreal.bus.gps_timestamp
        
        bus_line = busreal.bus.bus_line.replace("pothong_", "โพถ้อง ");
        speed = (busreal.bus.speed).toFixed()
        license_id = busreal.bus.license_id
        if(busreal.previous_stop){
            fromStation = busreal.previous_stop.stop_name
        }
        else fromStation = ' - '

        for(var i=0;i<Object.keys(busreal.stop_list).length;i++){
            if(busreal.stop_list[i].passed===false){
                toStation = busreal.stop_list[i].stop_name
                predicted_arrival_sec = busreal.stop_list[i].predict
                break;
            }
        }
    
        if(predicted_arrival_sec){

            if(predicted_arrival_sec >= 60 )
                predicted = (predicted_arrival_sec/60).toFixed() + " นาที"
            else if(predicted_arrival_sec < 60 )
                predicted = (predicted_arrival_sec).toFixed() + " วินาที"

        }
        else predicted = ' - '

        direction_name = busreal.stop_list[0].bus_name

        bustostop = (busreal.bus.bus_to_stop_in_metre).toFixed() +" "+ busreal.bus.unit
        
        // bustostop = (busreal.bus.bus_to_stop_in_metre).toFixed() + ' เมตร'
        // if(busreal.bus.bus_to_stop_in_metre > 1000){
            // bustostop = (busreal.bus.bus_to_stop_in_metre/1000).toFixed() + 'กิโลเมตร'
        // }

        for(var j=0;j<Object.keys(busreal.stop_list).length;j++){
            if(busreal.stop_list[j].nearest_to_user===true){
                nearest = busreal.stop_list[j].stop_name
            }
        }

        for(var k=0;k<Object.keys(busreal.stop_list).length;k++){
            if(busreal.stop_list[k].passed===false){
                stopcount++;
                if(busreal.stop_list[k].nearest_to_user===true){
                    break;
                }
            }
        }

    }

    if(item&&!bus_line){

        ti = item['bus'].gps_timestamp

        bus_line = item['bus'].bus_line.replace("pothong_", "โพธิ์ถ้อง ");
        speed = (item['bus'].speed).toFixed()
        license_id = item['bus'].license_id
        if(item['previous_stop']){
            fromStation = item['previous_stop'].stop_name
        }
        else fromStation = ' - '

        for(var x=0;x<Object.keys(item['stop_list']).length;x++){
            if(item['stop_list'][x].passed===false){
                toStation = item['stop_list'][x].stop_name
                predicted_arrival_sec = item['stop_list'][x].predict
                break;
            }
        }

        if(predicted_arrival_sec){

            if(predicted_arrival_sec >= 60 )
                predicted = (predicted_arrival_sec/60).toFixed() + " นาที"
            else if(predicted_arrival_sec < 60 )
                predicted = (predicted_arrival_sec).toFixed() + " วินาที"

        }
        else predicted = ' - '
        direction_name = item['stop_list'][0].bus_name
        
        bustostop = (item['bus'].bus_to_stop_in_metre).toFixed() +" "+item['bus'].unit
        
        // if(item['bus'].bus_to_stop_in_metre > 1000){
            // bustostop = (item['bus'].bus_to_stop_in_metre/1000).toFixed() + 'กม.'
        // }

        for(var y=0;y<Object.keys(item['stop_list']).length;y++){
            if(item['stop_list'][y].nearest_to_user===true){
                nearest = item['stop_list'][y].stop_name
            }
        }
    }
  

    return (
        <div style={divStyle} >
           <div style={divHead}>
                <span style={{fontSize:'24px', }}>{bus_line} &nbsp;({license_id})</span>
                <br/>
                <span style={{ fontSize:'16px'}}> {direction_name} </span>
            </div>
            
            <div style={divBody} >

                <table border='0' width='100%' style={{fontSize:'18px', marginTop:'5px'}} >
                <tbody>
                    <tr style={{height:'15%'}}>
                        <td >
                            <span style={{marginLeft:'5px', align:'center', fontSize:'16px' }} >ป้ายก่อนหน้า</span>
                        </td>
                        <td  align='center' rowSpan="3" width='10%'  > 
                            <img height="20%" width="55%" src={timeline}  alt="" style={{ paddingTop:'5px' }}/>
                        </td>
                        <td width='65%' >
                            <span style={{marginLeft:'10px', align:'center', fontSize:'16px' }} >{fromStation}</span>
                        </td>
                    </tr>

                    <tr style={{height:'15%'}}>
                        <td>
                            <span style={{marginLeft:'5px', align:'center', fontSize:'16px' }} >ป้ายถัดไป</span>
                        </td>
                       
                        <td >
                            <span style={{marginLeft:'10px', align:'center', fontSize:'16px' }} >{toStation}</span>
                        </td>
                    </tr>

                     <tr style={{height:'15%'}}>
                        <td>
                            <span style={{marginLeft:'5px', align:'center', fontSize:'16px' }} >ป้ายของคุณ</span>
                        </td>
                       
                        <td >
                            <span style={{marginLeft:'10px', align:'center', fontSize:'16px' }} >{nearest}</span>
                        </td>
                    </tr>
                </tbody>
                    
                </table>


                <span style={{ textAlign:'center', fontSize:'22px' }} >{stopcount} ป้าย , {bustostop} </span>
            </div>
            
            <div style={divinFooter}>
                <div  style={{fontSize:'20px', display:'inline', marginLeft:'15px'}}> 
                <span> {speed} กม./ชม. </span>
                <span align='right'> {ti}  </span>
                </div>
            </div>
        </div>
    );
  }
}    


// WEBPACK FOOTER //
// ./src/card.js